module.exports = __webpack_public_path__ + "img/clap_ios_802.png";